module.exports = __webpack_public_path__ + "img/16-OTJS-assess-your-employability-skills.2ddc7c22.svg";